import React from 'react';
export function UrgencyBar() {
  return <div className="bg-naranja text-white text-center py-2 px-4 text-sm font-semibold tracking-wide" data-id="element-267">
      🔴 72% de los cupos al precio de lanzamiento ya tomados — Cierra hoy
    </div>;
}